import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'

export type TRtm = 'Reseller' | 'Distributor' | 'Retail'
export type TPartnerFlag = 'Class' | 'Amplify' | 'Specialization'
export type TRequestAction = 'Add' | 'Delete' | 'Update'
export type TRequestStatus = 'New' | 'In Progress'

export enum WelcomeFlowBitClasses {
  None = 0,
  TopWwOph = 1,
  TopWwBps = 2,
  TopMarketOph = 4,
  TopMarketBps = 8,
  StrategicPrintServices = 16,
  StrategicMps = 32,
  StrategicPsServices = 64,
  TopDistributor = 128,
  TopRetailer = 512,
  Other = 256,
}

export interface IWelcomeFlowPartner {
  EntryID: number
  AmplifyTrack: string
  BitClass: WelcomeFlowBitClasses
  BitSpecialization: number
  Country: string
  CountryCode: string
  GeoMarket: string
  GeoRegion: string
  PartnerRanks?: string
  HierarchyType: string
  LocationId: string
  MarketL2: string
  MarketL3: string
  MarketL4: string
  PartnerId: string
  PartnerName: string
  RTM: TRtm
  STBusinessUnit?: string // slash (/) separated value
  STLeadPBM: number // id (?)
  STRequestAction?: TRequestAction
  STRequestId: number
  STRequestStatus: TRequestStatus
  STRole: string
}

export interface IWelcomeFlowPartnerFlag {
  Icon: string // icon name
  IsTopMarket: 1 | 0
  IsTopWW: 1 | 0
  Offering: ProgramTypes
  PartnerFlag: string
  RTM: TRtm
  SortOrder: number
  Title: string
  Type: TPartnerFlag
}

export interface IWelcomeFlowRtmOption {
  RTM: TRtm
  SortOrder: number
}

export interface IWelcomeFlowUserData {
  BusinessUnit?: string // slash (/) separated value
  Email: string
  FirstName: string
  LastName: string
  RTM: TRtm
  Roles: string
  ManagerEmail: string
  ManagerFirstName: string
  ManagerLastName: string
}

export interface IWelcomeFlowMissingAssignment {
  PartnerID: string
  Market: string
  Country: string
  PartnerName: string
  ProgramType: string
  Role: string
  BusinessUnit: string
}

export interface IWelcomeFlowData {
  PartnerFlags: IWelcomeFlowPartnerFlag[]
  Partners: IWelcomeFlowPartner[]
  RtmList: IWelcomeFlowRtmOption[]
  UserData: IWelcomeFlowUserData[]
  MissingAssignment: IWelcomeFlowMissingAssignment[]
}

export interface IFetchWelcomeFlowPartners {
  status: 'success' | 'failure'
  data: IWelcomeFlowData
}
